// frontend/src/components/layout/TopBar.jsx
import React           from "react"
import { useDispatch } from "react-redux"
import { logout }      from "../../features/userSlice"
import { useNavigate } from "react-router-dom"
import "./TopBar.css"

const TopBar = ({
  user,
  onToggleSidebar,
  onOpenPanel,
  onOpenCmd,
  rightPanelTab,
}) => {
  const dispatch  = useDispatch()
  const navigate  = useNavigate()

  const handleLogout = () => {
    dispatch(logout())
    navigate("/login", { replace: true })
  }

  return (
    <header className="topbar">

      {/* Brand / Logo */}
      <div className="topbar-brand">
        <button
          className="topbar-ham"
          onClick={onToggleSidebar}
          title="Toggle Sidebar (Ctrl+B)"
        >
          <HamIc />
        </button>
        <div className="topbar-logo">S</div>
          <span className="topbar-name">
            <em>Singhal</em><span className="topbar-name-erp">ERP</span>
          </span>      
        </div>
      {/* Search */}
      <button
        className="topbar-search"
        onClick={onOpenCmd}
        title="Command Palette (Ctrl+K)"
      >
        <SearchIc />
        <span className="topbar-search-text">
          Search forms, records…
        </span>
        <kbd className="topbar-kbd">Ctrl+K</kbd>
      </button>

      <div className="topbar-spacer" />

      {/* New */}
      <TbBtn
        onClick={() => onOpenCmd?.()}
        title="New record"
        label="New"
        icon={<PlusIc />}
      />

      {/* Notifications */}
      <TbBtn
        onClick={() => onOpenPanel("notif")}
        active={rightPanelTab === "notif"}
        badge={4}
        title="Notifications"
        icon={<BellIc />}
      />

      {/* Chat */}
      <TbBtn
        onClick={() => onOpenPanel("chat")}
        active={rightPanelTab === "chat"}
        badge={2}
        title="Internal Chat"
        icon={<ChatIc />}
      />

      <div className="topbar-divider" />

      {/* User */}
      <div className="topbar-user">
        <div className="topbar-avatar">
          {(user?.Name || user?.emp_id || "U")
            .charAt(0).toUpperCase()}
        </div>
        <div className="topbar-user-info">
          <span className="topbar-user-name">
            {user?.Name || user?.emp_id}
          </span>
          <span className="topbar-user-role">
            {[user?.entity, user?.division]
              .filter(Boolean).join(" · ") || "User"}
          </span>
        </div>
      </div>

      {/* Logout */}
      <TbBtn
        onClick={handleLogout}
        title="Logout"
        icon={<LogoutIc />}
      />

    </header>
  )
}

const TbBtn = ({ onClick, active, badge, title, label, icon }) => (
  <button
    className={`topbar-btn ${active ? "active" : ""}`}
    onClick={onClick}
    title={title}
  >
    {icon}
    {label && <span>{label}</span>}
    {badge > 0 && (
      <span className="topbar-badge">{badge}</span>
    )}
  </button>
)

// Icons
const Ic = ({ d, d2, children }) => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" style={{ display: "block" }}>
    {d  && <path d={d}  stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>}
    {d2 && <path d={d2} stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>}
    {children}
  </svg>
)

const HamIc    = () => <Ic d="M2 4h12M2 8h12M2 12h12" />
const PlusIc   = () => <Ic d="M8 2v12M2 8h12" />
const SearchIc = () => <Ic><circle cx="6.5" cy="6.5" r="4" stroke="currentColor" strokeWidth="1.3"/><path d="M10 10l3.5 3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></Ic>
const BellIc   = () => <Ic d="M8 2a5 5 0 00-5 5v3l-1 2h12l-1-2V7a5 5 0 00-5-5z" d2="M6.5 13.5a1.5 1.5 0 003 0" />
const ChatIc   = () => <Ic d="M1 3h14v8a1 1 0 01-1 1H4l-3 2V4a1 1 0 011-1z" />
const LogoutIc = () => <Ic d="M6 8h8M11 5l3 3-3 3M8 3H3v10h5" />

export default TopBar